import React from 'react'
import Wrapper from '../components/Wrapper.js'
import { useState, useEffect } from 'react'
import Api from '../Api.js';
import moment from 'moment';
import { useMemo } from 'react';
import { Slider } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import qs from 'query-string';
import { useSelector } from 'react-redux';

function valuetext(value) {
  return `${value?.toLocaleString()} ֏`;
}

const minDistance = 100;

export default function Wallet() {
  const location = useLocation();
  const navigate = useNavigate();
  const query = qs.parse(location.search);
  const userData = useSelector((state) => state.manager.employee);

  const isAdmin = userData?.user_id === 86 || userData?.user?.id === 86 || userData?.user?.id === 1734 || userData?.user?.id === 2 ;

  // Style for table cells with ellipsis
  const cellStyle = {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };

  const [result, setWallet] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(query.agent || '');
  const [startDate, setStartDate] = useState(
    query.start_date || moment().startOf('month').format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(
    query.end_date || moment().format('YYYY-MM-DD')
  );
  const [amountValue, setAmountValue] = useState([
    Number(query.amount_min) || 0,
    Number(query.amount_max) || 1000000
  ]);
  const [amountRange, setAmountRange] = useState([0, 1000000]);

  const fetchWalletData = async (params) => {
    const { data } = await Api.getPurchase(params);
    setWallet(data);
    
    // Calculate min/max from the data
    if (data && data.length > 0) {
      const amounts = data.map(item => Number(item.amount));
      const min = Math.min(...amounts);
      const max = Math.max(...amounts);
      setAmountRange([min, max]);
      
      // Only set initial values if not in query params
      if (!params.amount_min && !params.amount_max) {
        setAmountValue([min, max]);
      }
    } else {
      // Set default range when no data
      setAmountRange([0, 1000000]);
      if (!params.amount_min && !params.amount_max) {
        setAmountValue([0, 1000000]);
      }
    }
  };

  const handleSearch = () => {
    const params = {
      start_date: startDate,
      end_date: endDate,
      amount_min: amountValue[0],
      amount_max: amountValue[1]
    };
    
    if (isAdmin && selectedAgent) {
      params.agent = selectedAgent;
    }
    
    const querystring = qs.stringify(params, {
      skipEmptyString: true,
    });
    
    navigate(querystring ? `?${querystring}` : '?', { replace: true });
  };

  const handleAmountChange = (event, newValue, activeThumb) => {
    if (newValue[1] - newValue[0] < minDistance) {
      if (activeThumb === 0) {
        const clamped = Math.min(newValue[0], amountRange[1] - minDistance);
        setAmountValue([clamped, clamped + minDistance]);
      } else {
        const clamped = Math.max(newValue[1], minDistance);
        setAmountValue([clamped - minDistance, clamped]);
      }
    } else {
      setAmountValue(newValue);
    }
  };

  useEffect(() => {
    // Fetch agents list for admin user
    if (isAdmin) {
      (async () => {
        try {
          const { data } = await Api.gerAgentList();
          setAgentList(data);
        } catch (error) {
          console.error('Error fetching agents:', error);
        }
      })();
    }
  }, [isAdmin]);

  useEffect(() => {
    const params = qs.parse(location.search);
    
    // Include default values if not in query params
    const apiParams = {
      start_date: params.start_date || startDate,
      end_date: params.end_date || endDate,
      amount_min: params.amount_min || amountValue[0],
      amount_max: params.amount_max || amountValue[1]
    };
    
    if (isAdmin && params.agent) {
      apiParams.agent = params.agent;
    }
    
    fetchWalletData(apiParams);
  }, [location.search])
  const { totalPayed, totalUnPayed } = useMemo(() => {
    let totalPayed = 0;
    let totalUnPayed = 0;

    result.forEach(item => {
      totalUnPayed += Number(item.amount);
      if (item.is_payed) {
        totalPayed += Number(item.amount);
      }
    });

    return { totalPayed, totalUnPayed };
  }, [result]);
  return (
    <Wrapper>
      <div className="reports">
        <div className="table-cont">
          <div className="filter-section" style={{ marginBottom: '20px', display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500' }}>Սկսած ամսաթիվ:</label>
              <input 
                type="date" 
                value={startDate} 
                onChange={(e) => setStartDate(e.target.value)}
                style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500' }}>Մինչև ամսաթիվ:</label>
              <input 
                type="date" 
                value={endDate} 
                onChange={(e) => setEndDate(e.target.value)}
                style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', minWidth: '300px', flex: 1 }}>
              <label style={{ fontSize: '14px', fontWeight: '500' }}>
                Գումար: {amountValue[0]?.toLocaleString()} ֏ - {amountValue[1]?.toLocaleString()} ֏
              </label>
              <Slider
                getAriaLabel={() => "Գումարի միջակայք"}
                value={amountValue}
                min={amountRange[0]}
                max={amountRange[1]}
                onChange={handleAmountChange}
                valueLabelDisplay="auto"
                getAriaValueText={valuetext}
                disableSwap
              />
            </div>
            {isAdmin && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', minWidth: '200px' }}>
                <label style={{ fontSize: '14px', fontWeight: '500' }}>Գործակալ:</label>
                <select
                  value={selectedAgent}
                  onChange={(e) => setSelectedAgent(e.target.value)}
                  style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
                >
                  <option value="">Բոլորը</option>
                  {agentList.map((agent) => (
                    <option key={agent.id} value={agent.id}>
                      {agent.user?.first_name} {agent.user?.last_name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <button onClick={handleSearch} className="btn btn-primary" style={{ padding: '8px 20px' }}>
              Որոնել
            </button>
          </div>
          <div>
            <table>
              {result.length > 0 ? (
                <tbody>
                  <tr>
                    <th>Կազմակերպության անուն</th>
                    <th>Առաջադրանքի անուն</th>
                    <th>Ստեղծել է</th>
                    <th>Գումար</th>
                    <th>Կարգավիճակ</th>
                  </tr>
                  {result.map((item, index) => {
                    return (
                      <tr className='report-list' key={index}>
                        <td className='report-item' style={cellStyle} title={item.company_name}>{item.company_name}</td>
                        <td className='report-item' style={cellStyle} title={item.task_title}>{item.task_title}</td>
                        <td className='report-item' style={cellStyle} title={item.task_creator_name}>{item.task_creator_name}</td>
                        <td className='report-item' style={cellStyle} title={item.amount}>{item.amount}</td>
                        <td className='report-item' style={cellStyle} title={item.is_payed ? "Վճարված" : "Ընթացքում է"}>{item.is_payed ? "Վճարված" : "Ընթացքում է"}</td>
                      </tr>
                    )
                  })}
                </tbody>
              ) : (
                <span>Առաջադրանքներ չկան</span>
              )}
            </table>
          </div>
          <div className='d-flex flex-column report-summary'>
            <p>Վճարված գումար: {totalPayed}</p>
            <p>Ընդհանուր գումար: {totalUnPayed}</p>
            <p>Չվճարված գումար: {totalUnPayed - totalPayed}</p>
          </div>
        </div>
      </div>


    </Wrapper>
  )
}
